// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tw","controlPlay":"tx","controlElement":"ty","lowerControlWrapper":"tz","controlBottomOffset":"tA","lowerControlIconWrapper":"tB","lowerControlIcon":"tC","show":"tD"};